import Input from "@/components/Input";
import AddDegreeButton from "@/screens/common/Person/AddDegreeButton";
import { useState } from "react";
import { useTranslation } from "@/i18n/client";
import { DegreeBeforeName } from "@/screens/common/Degree/DegreeBeforeName";
import { DegreeAfterName } from "@/screens/common/Degree/DegreeAfterName";
import { FormInputProps } from "@/types";
import { InputTooltip } from "@/components/InputTooltip";

interface PersonProps {
  nameProps: FormInputProps;
  surnameProps: FormInputProps;
  degreeBeforeIdProps: FormInputProps;
  degreeAfterIdProps: FormInputProps;
  disabled?: boolean;
  isPrefilledCustomer?: boolean;
  showTooltip?: boolean;
}

export const Person = ({
  nameProps,
  surnameProps,
  degreeBeforeIdProps,
  degreeAfterIdProps,
  disabled,
  isPrefilledCustomer,
  showTooltip = false,
}: PersonProps) => {
  const { t } = useTranslation(["customer", "hints"]);

  const [degreeInputsManuallyShown, setDegreeInputsManuallyShown] = useState(false);
  const showDegreeInputs = degreeInputsManuallyShown || degreeBeforeIdProps.value !== "" || degreeAfterIdProps.value !== "";
  const showAddDegreeButton = !isPrefilledCustomer;
  const showDegreeBeforeName = isPrefilledCustomer ? degreeBeforeIdProps.value : true;
  const showDegreeAfterName = isPrefilledCustomer ? degreeAfterIdProps.value : true;

  return (
    <>
      <InputTooltip
        tooltipProps={{
          label: t("hints:customer.name"),
        }}
        showTooltip={showTooltip}>
        <Input
          label={t("name")}
          {...nameProps}
          disabled={disabled ?? isPrefilledCustomer}
          name="firstName"
          id="firstName"
          autoComplete="given-name"
          pii
        />
      </InputTooltip>
      <InputTooltip
        tooltipProps={{
          label: t("hints:customer.surname"),
        }}
        showTooltip={showTooltip}>
        <Input
          label={t("surname")}
          {...surnameProps}
          disabled={disabled ?? isPrefilledCustomer}
          name="lastName"
          id="lastName"
          autoComplete="family-name"
          pii
        />
      </InputTooltip>
      {showDegreeInputs ? (
        <>
          {showDegreeBeforeName && <DegreeBeforeName {...degreeBeforeIdProps} disabled={disabled ?? isPrefilledCustomer} />}
          {showDegreeAfterName && <DegreeAfterName {...degreeAfterIdProps} disabled={disabled ?? isPrefilledCustomer} />}
        </>
      ) : (
        showAddDegreeButton && <AddDegreeButton onClick={() => setDegreeInputsManuallyShown(true)} disabled={disabled} />
      )}
    </>
  );
};
